import { Box, styled } from '@mui/material'

export const StyledMainBox = styled(Box)(() => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
}))
